import { saveAs } from "file-saver";

export class Export {
  public static csv(data: any, filename: string): void {
    const blob = new Blob([data], { type: "text/csv" });
    saveAs(blob, filename);
  }
}
